import { App as AntdApp } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { Suspense, useContext } from 'react';
import './App.scss';
import { AppContext } from './contexts/app.context';
import useRouteElements from './hooks/useRouteElements';
import { useServiceWorkerVersionCheck } from './hooks/useServiceWorkerVersionCheck';
import { useUserResources } from './hooks/useUserResource';
import type { IResourceFullAccessDetail } from './types/master_data/userResource.type';
dayjs.locale('vi');

function App() {
  const { resources, resourcePermissionLoading } = useContext(AppContext);

  useUserResources();
  useServiceWorkerVersionCheck();

  const routeElements = useRouteElements(resources as IResourceFullAccessDetail[], !!resourcePermissionLoading);

  return (
    <div className='app-container'>
      <Suspense>
        <AntdApp>{routeElements}</AntdApp>
      </Suspense>
    </div>
  );
}

export default App;
